import layouts from 'scripts/util/layouts'

export default class Form {
  constructor (selector, clickHandler) {
    this.$root = $(selector);
    this.$root.on('submit', this.onSubmit.bind(this));
    this.$submitButton = this.$root.find('#submit');
    this.$confirmButton = this.$root.find('#confirm');
    this.$edit = this.$root.find('.bForm-edit');
    this.$confirm = this.$root.find('.bForm-confirm');
    this.$privacy = this.$root.find('.bForm-privacy');
    this.$back = this.$root.find('.bForm-submit-back');
    this.$back.on('click', this.onClickBack.bind(this));
    this.mode = 'edit';
  }
  onSubmit (event) {
    const $button = $(event.currentTarget);
    if (this.mode === 'edit') {
      event.preventDefault();
      this.removeError();
      this.validate();
      if (this.errors.length) {
        this.renderError();
        return;
      }
      this.changeToSubmitMode();
    }
  }
  onClickBack (event) {
    this.changeToEditMode();
  }
  changeToSubmitMode () {
    this.$submitButton.show();
    this.$back.show();
    this.$confirm.show();
    this.$edit.hide();
    this.$confirmButton.hide();
    this.$privacy.hide();
    this.mode = 'submit';
    this.showConfirm();
    this.scrollToTop();
  }
  changeToEditMode() {
    this.$submitButton.hide();
    this.$back.hide();
    this.$confirm.hide();
    this.$edit.show();
    this.$confirmButton.show();
    this.$privacy.show();
    this.mode = 'edit';
    this.scrollToTop();
  }
  showConfirm () {
    $('[data-form-field]').each((index, el) => {
      const name = $(el).data('name');
      const value = this
        .getInputValue($(`[name="${name}"]`), true)
        .replace(/\r\n/g, "<br />")
        .replace(/(\n|\r)/g, "<br />");
      $(el).find('._value').html(value);
    });
  }
  hideConfirm () {
  }
  validate () {
    this.errors = [];
    this.$root.find('.bTextField').each((index, el) => {
      this.validateTextField($(el));
    });
    this.$root.find('.bRadioGroup').each((index, el) => {
      this.validateRadioGroup($(el));
    });
    this.$root.find('.bCheckBoxGroup').each((index, el) => {
      this.validateCheckBoxGroup($(el));
    });
    this.$root.find('.bSelect')
      .filter((index, el) => {
        return $(el).closest('.bBirthdaySelector').length == 0
      })
      .each((index, el) => {
        this.validateSelect($(el));
      });
    this.$root.find('.bReadOnly').each((index, el) => {
      this.validateReadOnly($(el));
    });
    this.$root.find('.bBirthdaySelector').each((index, el) => {
      this.validateBirthdaySelector($(el));
    });
  }
  getInputType ($el) {
    if ($el.is('select')) return 'select';
    if ($el.is('textarea')) return 'textarea';
    return $el.attr('type');
  }
  getInputValue ($el, fallback = false) {
    let val;
    let emptyText;
    if ($el.is('input[type=radio]')) {
      val = $el.filter(':checked').val();
      emptyText = '未選択';
    }
    else if ($el.is('input[type=checkbox]')) {
      val = $el.filter(':checked').map((index, el) => $(el).val()).toArray().join('、');
      emptyText = '未選択';
    }
    else if ($el.is('select')) {
      val = $el.find('option:checked').val();
      emptyText = '未選択';
    } else {
      val = $el.val();
      emptyText = '未入力';
    }
    if (this.isEmpty(val) && fallback) {
      return emptyText;
    }
    return val;
  }
  getRequired ($el) {
    return $el.prop('required');
  }
  getMinLength ($el) {
    const length = $el.attr('minlength');
    if (!length) return null;
    if (isNaN(parseInt(length))) return null;
    return length;
  }
  getMaxLength ($el) {
    const length = $el.attr('maxlength');
    if (!length) return null;
    if (isNaN(parseInt(length))) return null;
    return length;
  }
  getConfirm ($el) {
    const confirm = $el.data('confirm');
    if (!confirm) return null;
    if (confirm.length <= 0) return null;
    return confirm;
  }
  getConfirmName ($el) {
    const name = $el.data('confirm_name');
    if (!name) return null;
    if (name.length <= 0) return null;
    return name;
  }
  removeError () {
    this.$root.find('.bFormError').remove();
  }
  renderError () {
    this.errors.forEach((error) => {
      error.$el.append(`<div class="bFormError">${error.message}</div>`);
    });
    this.scrollToTop();
  }
  scrollToTop () {
    $.Velocity(this.$root.find('.bForm-inner'), 'scroll', {
      duration: 300,
      easing: "easeInOutQuad",
      offset: layouts.getHeaderOffset()
    });
  }
  validateTextField ($el) {
    const $input = $el.find('input, textarea');
    const displayName = $input.data('name');
    const type = this.getInputType($input);
    const value = this.getInputValue($input);
    const required = this.getRequired($input);
    const minLength = this.getMinLength($input);
    const maxLength = this.getMaxLength($input);
    const confirm = this.getConfirm($input);
    const confirmName = this.getConfirmName($input);
    if (required && this.isEmpty(value)) {
      this.errors.push({
        $el,
        message: `${displayName}を入力してください。`
      });
      return;
    }
    if (minLength && !this.isMinLength(minLength, value)) {
      this.errors.push({
        $el,
        message: `${displayName}には${minLength}字以上入力してください。`
      });
      return;
    }
    if (maxLength && !this.isMaxLength(maxLength, value)) {
      this.errors.push({
        $el,
        message: `${displayName}には${maxLength}字以内で入力してください。`
      });
      return;
    }
    if (type === 'tel' && !this.isTel(value)) {
      this.errors.push({
        $el,
        message: `${displayName}には半角の数字とハイフンのみ入力してください。`
      });
      return;
    }
    if (type === 'email' && !this.isEmail(value)) {
      this.errors.push({
        $el,
        message: `メールアドレスの形式で入力してください`
      });
      return;
    }
    if (type === 'number' && !this.isNumber(value)) {
      this.errors.push({
        $el,
        message: `${displayName}には数値を入力してください。`
      });
      return;
    }
    if (confirm) {
      if ($(`[name=${confirm}]`).val() !== value) {
        this.errors.push({
          $el,
          message: `${confirmName}と一致していません。`
        });
        return;
      }
    }
  }
  validateSelect ($el) {
    const $select = $el.find('select');
    const displayName = $select.data('name');
    const required = this.getRequired($select);
    const value = this.getInputValue($select);
    if (required && this.isEmpty(value)) {
      this.errors.push({
        $el,
        message: `${displayName}を選択してください。`
      });
      return;
    }
    return;
  }
  validateRadioGroup ($el) {
    const $input = $el.find('input');
    const displayName = $el.data('name');
    const required = $el.data('required');
    const value = this.getInputValue($input);
    if (required && this.isEmpty(value)) {
      this.errors.push({
        $el,
        message: `${displayName}を選択してください。`
      });
    }
  }
  validateCheckBoxGroup ($el) {
    const $input = $el.find('input');
    const displayName = $el.data('name');
    const required = $el.data('required');
    const values = this.getInputValue($input);
    if (required && values.length === 0) {
      this.errors.push({
        $el,
        message: `${displayName}を選択してください。`
      });
    }
  }
  validateReadOnly ($el) {
    const $input = $el.find('input');
    const displayName = $input.data('name');
    const type = $el.data('input-type');
    const value = this.getInputValue($input);
    const required = this.getRequired($input);
    const minLength = this.getMinLength($input);
    const maxLength = this.getMaxLength($input);
    if (required && this.isEmpty(value)) {
      const text = ['radio', 'select', 'checkbox'].findIndex((value) => value === type) !== -1
        ? '選択'
        : '入力';
      this.errors.push({
        $el,
        message: `${displayName}を${text}してください。`
      });
      return;
    }
    if (minLength && !this.isMinLength(minLength, value)) {
      this.errors.push({
        $el,
        message: `${displayName}には${minLength}字以上入力してください。`
      })
      return;
    }
    if (maxLength && !this.isMaxLength(maxLength, value)) {
      this.errors.push({
        $el,
        message: `${displayName}には${maxLength}字以内で入力してください。`
      });
      return;
    }
    if (type === 'email' && !this.isEmail(value)) {
      this.errors.push({
        $el,
        message: `メールアドレスの形式で入力してください`
      });
      return;
    }
    if (type === 'number' && !this.isNumber(value)) {
      this.errors.push({
        $el,
        message: `${displayName}には数値を入力してください。`
      });
      return;
    }
    return;
  }
  validateBirthdaySelector ($el) {
    const $select = $el.find('select');
    let isValid = true;
    $select.each((index, select) => {
      if (!isValid) return;
      const $select = $(select);
      const required = $select.prop('required');
      const value = this.getInputValue($select);
      if (required && this.isEmpty(value)) {
        this.errors.push({
          $el,
          message: `生年月日を選択してください。`
        })
        isValid = false;
        return;
      }
    });
    return;
  }
  isEmpty (text) {
    if (!text) return true;
    if (text.length <= 0) return true;
    return false;
  }
  isEmail (text) {
    const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
    return regexp.test(text);
  }
  isMinLength (length, value) {
    return value.length >= length;
  }
  isMaxLength (length, value) {
    return value.length <= length;
  }
  isNumber (value) {
    if (isNaN(Number(value))) return false;
    return true;
  }
  isTel (value) {
    const regexp = /^(\d*-{0,1}\d*-{0,1}\d*)$/;
    return regexp.test(value);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/base/Form.js